module.exports = __webpack_public_path__ + "static/img/graph_image_type3.daaae94d.png";